import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.railway.performance');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-railway-performance',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.railway.performance/view.scss */
/* src/app/page.railway.performance/view.scss: no such file or directory */`],
})
export class PageRailwayPerformanceComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public categories: any[] = [];
    public loading: boolean = true;
    public saving: boolean = false;
    public showForm: boolean = false;
    public form: any = {
        type: 'category',
        id: '',
        categoryId: '',
        name: ''
    };
    public assessmentTypes: any[] = [
        { key: 'precision_diagnosis', label: '정밀진단' },
        { key: 'safety', label: '안전성' },
        { key: 'durability', label: '내구성' },
        { key: 'usability', label: '사용성' }
    ];
    public answerTypes: any[] = [
        { key: 'scale5', label: '5점 척도' },
        { key: 'yes_no', label: '예 / 아니오' },
        { key: 'text', label: '주관식' }
    ];

    public showQuestionnaire: boolean = false;
    public questionnaireLoading: boolean = false;
    public questionnaireSaving: boolean = false;
    public questionnaire: any = {
        category: null,
        item: null,
        assessment: null,
        questions: []
    };
    public questionForm: any = {
        id: '',
        content: '',
        answerType: 'scale5',
        existingReferences: [],
        referenceFiles: [],
        removedReferenceIds: []
    };
    public referenceDragging: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public get itemCount(): number {
        return this.categories.reduce((total, category) => total + (category.items?.length || 0), 0);
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('list');
        if (code === 200) {
            this.categories = data.categories || [];
        } else {
            await this.service.modal.error(this.message(data, '성능평가 항목을 불러오지 못했습니다.'));
        }
        this.loading = false;
        await this.service.render();
    }

    public async openCategoryForm(category: any = null) {
        this.form = {
            type: 'category',
            id: category?.id || '',
            categoryId: '',
            name: category?.name || ''
        };
        this.showForm = true;
        await this.service.render();
    }

    public async openItemForm(category: any, item: any = null) {
        this.form = {
            type: 'item',
            id: item?.id || '',
            categoryId: category.id,
            categoryName: category.name,
            name: item?.name || ''
        };
        this.showForm = true;
        await this.service.render();
    }

    public async closeForm() {
        if (this.saving) return;
        this.showForm = false;
        await this.service.render();
    }

    public async saveForm() {
        const name = (this.form.name || '').trim();
        if (!name || this.saving) return;

        this.saving = true;
        await this.service.render();

        let action = '';
        let payload: any = { name };
        if (this.form.type === 'category') {
            action = this.form.id ? 'update_category' : 'create_category';
            if (this.form.id) payload.id = this.form.id;
        } else {
            action = this.form.id ? 'update_item' : 'create_item';
            if (this.form.id) payload.id = this.form.id;
            else payload.category_id = this.form.categoryId;
        }

        const { code, data } = await wiz.call(action, payload);
        this.saving = false;
        if (code === 200) {
            this.showForm = false;
            await this.load();
            return;
        }

        await this.service.render();
        await this.service.modal.error(this.message(data, '저장하지 못했습니다.'));
    }

    public async deleteCategory(category: any) {
        const itemCount = category.items?.length || 0;
        const confirmed = await this.service.modal.show({
            title: '분류 삭제',
            message: itemCount > 0
                ? `“${category.name}” 분류와 세부항목 ${itemCount}개를 모두 삭제하시겠습니까?`
                : `“${category.name}” 분류를 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
            status: 'warning'
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call('delete_category', { id: category.id });
        if (code === 200) {
            await this.load();
        } else {
            await this.service.modal.error(this.message(data, '분류를 삭제하지 못했습니다.'));
        }
    }

    public async deleteItem(category: any, item: any) {
        const confirmed = await this.service.modal.show({
            title: '세부항목 삭제',
            message: `“${item.name}” 세부항목을 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
            status: 'warning'
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call('delete_item', { id: item.id });
        if (code === 200) {
            await this.load();
        } else {
            await this.service.modal.error(this.message(data, '세부항목을 삭제하지 못했습니다.'));
        }
    }

    public getQuestionCount(item: any, assessmentType: string): number {
        return item.question_counts?.[assessmentType] || 0;
    }

    public async openQuestionnaire(category: any, item: any, assessment: any) {
        this.questionnaire = {
            category,
            item,
            assessment,
            questions: []
        };
        this.resetQuestionForm();
        this.showQuestionnaire = true;
        this.questionnaireLoading = true;
        await this.service.render();
        await this.loadQuestionnaire();
    }

    public async loadQuestionnaire() {
        const { code, data } = await wiz.call('questionnaire', {
            item_id: this.questionnaire.item.id,
            assessment_type: this.questionnaire.assessment.key
        });
        this.questionnaireLoading = false;
        if (code !== 200) {
            this.showQuestionnaire = false;
            await this.service.render();
            await this.service.modal.error(this.message(data, '설문지를 불러오지 못했습니다.'));
            return;
        }

        this.questionnaire.category = data.category;
        this.questionnaire.item = data.item;
        this.questionnaire.questions = data.questions || [];
        await this.service.render();
    }

    public async closeQuestionnaire() {
        if (this.questionnaireSaving) return;
        this.resetQuestionForm();
        this.showQuestionnaire = false;
        await this.load();
    }

    public editQuestion(question: any) {
        this.releaseReferencePreviews();
        this.questionForm = {
            id: question.id,
            content: question.content,
            answerType: question.answer_type,
            existingReferences: [...(question.reference_images || [])],
            referenceFiles: [],
            removedReferenceIds: []
        };
        this.service.render();
    }

    public cancelQuestionEdit() {
        this.resetQuestionForm();
        this.service.render();
    }

    public getReferenceImageUrl(reference: any): string {
        const version = reference?.updated || '';
        return `/wiz/api/page.railway.performance/reference_image?id=${encodeURIComponent(reference?.id || '')}&v=${encodeURIComponent(String(version))}`;
    }

    public async selectReferenceImages() {
        if (this.questionnaireSaving) return;
        const files = await this.service.file.select({
            accept: 'image/jpeg,image/png,image/webp',
            multiple: true
        });
        if (!files || files.length === 0) return;
        await this.addReferenceImages(files);
    }

    public onReferenceDragOver(event: DragEvent) {
        event.preventDefault();
        if (this.questionnaireSaving) return;
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
        this.referenceDragging = true;
    }

    public onReferenceDragLeave(event: DragEvent) {
        event.preventDefault();
        this.referenceDragging = false;
    }

    public async onReferenceDrop(event: DragEvent) {
        event.preventDefault();
        this.referenceDragging = false;
        if (this.questionnaireSaving) return;
        const files = event.dataTransfer?.files;
        if (!files || files.length === 0) return;
        await this.addReferenceImages(files);
    }

    public removeExistingReference(reference: any) {
        if (this.questionnaireSaving) return;
        this.questionForm.existingReferences = this.questionForm.existingReferences.filter(
            (item: any) => item.id !== reference.id
        );
        if (!this.questionForm.removedReferenceIds.includes(reference.id)) {
            this.questionForm.removedReferenceIds.push(reference.id);
        }
        this.service.render();
    }

    public removeNewReference(index: number) {
        if (this.questionnaireSaving) return;
        const reference = this.questionForm.referenceFiles[index];
        if (reference?.preview) URL.revokeObjectURL(reference.preview);
        this.questionForm.referenceFiles.splice(index, 1);
        this.service.render();
    }

    public formatFileSize(size: number): string {
        if (!size) return '';
        if (size < 1024 * 1024) return `${Math.max(1, Math.round(size / 1024))}KB`;
        return `${(size / 1024 / 1024).toFixed(1)}MB`;
    }

    public async saveQuestion() {
        const content = (this.questionForm.content || '').trim();
        if (!content || this.questionnaireSaving) return;
        this.questionnaireSaving = true;
        await this.service.render();

        const action = this.questionForm.id ? 'update_question' : 'create_question';
        const payload: any = {
            content,
            answer_type: this.questionForm.answerType
        };
        if (this.questionForm.id) {
            payload.id = this.questionForm.id;
        } else {
            payload.item_id = this.questionnaire.item.id;
            payload.assessment_type = this.questionnaire.assessment.key;
        }

        const { code, data } = await wiz.call(action, payload);
        if (code !== 200) {
            this.questionnaireSaving = false;
            await this.service.render();
            await this.service.modal.error(this.message(data, '문항을 저장하지 못했습니다.'));
            return;
        }

        const questionId = this.questionForm.id || data.id;
        if (this.questionForm.referenceFiles.length > 0) {
            const formData = new FormData();
            formData.append('question_id', questionId);
            for (const reference of this.questionForm.referenceFiles) {
                formData.append('file[]', reference.file);
            }
            const uploadResult: any = await this.service.file.upload(
                '/wiz/api/page.railway.performance/upload_reference_image',
                formData
            );
            if (!uploadResult || uploadResult.code !== 200) {
                this.questionForm.id = questionId;
                this.questionnaireSaving = false;
                await this.service.render();
                await this.service.modal.error(this.message(
                    uploadResult?.data,
                    '문항은 저장됐지만 기준 사진을 업로드하지 못했습니다.'
                ));
                return;
            }
            this.releaseReferencePreviews();
            this.questionForm.referenceFiles = [];
            this.questionForm.existingReferences = [
                ...this.questionForm.existingReferences,
                ...(uploadResult.data?.reference_images || [])
            ];
        }

        for (const referenceId of [...this.questionForm.removedReferenceIds]) {
            const deleteResult = await wiz.call('delete_reference_image', { id: referenceId });
            if (deleteResult.code !== 200) {
                this.questionForm.id = questionId;
                this.questionnaireSaving = false;
                await this.service.render();
                await this.service.modal.error(this.message(
                    deleteResult.data,
                    '문항은 저장됐지만 기준 사진을 삭제하지 못했습니다.'
                ));
                return;
            }
            this.questionForm.removedReferenceIds = this.questionForm.removedReferenceIds.filter(
                (id: string) => id !== referenceId
            );
        }

        this.questionnaireSaving = false;
        this.resetQuestionForm();
        await this.loadQuestionnaire();
    }

    public async deleteQuestion(question: any) {
        const confirmed = await this.service.modal.show({
            title: '문항 삭제',
            message: '이 설문 문항을 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error',
            status: 'warning'
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call('delete_question', { id: question.id });
        if (code === 200) {
            if (this.questionForm.id === question.id) this.cancelQuestionEdit();
            await this.loadQuestionnaire();
        } else {
            await this.service.modal.error(this.message(data, '문항을 삭제하지 못했습니다.'));
        }
    }

    public answerTypeLabel(answerType: string): string {
        return this.answerTypes.find(type => type.key === answerType)?.label || answerType;
    }

    private async addReferenceImages(files: File[] | FileList) {
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
        const selected = Array.from(files as any) as File[];
        for (const file of selected) {
            const hasAllowedExtension = /\.(jpe?g|png|webp)$/i.test(file.name || '');
            if (!allowedTypes.includes(file.type) && !hasAllowedExtension) {
                await this.service.modal.error(`${file.name}: JPG, PNG, WEBP 사진만 업로드할 수 있습니다.`);
                continue;
            }
            if (file.size > 10 * 1024 * 1024) {
                await this.service.modal.error(`${file.name}: 기준 사진은 파일당 10MB 이하로 업로드해주세요.`);
                continue;
            }
            const duplicated = this.questionForm.referenceFiles.some((item: any) =>
                item.file.name === file.name &&
                item.file.size === file.size &&
                item.file.lastModified === file.lastModified
            );
            if (duplicated) continue;
            this.questionForm.referenceFiles.push({
                file,
                preview: URL.createObjectURL(file)
            });
        }
        await this.service.render();
    }

    private resetQuestionForm() {
        this.releaseReferencePreviews();
        this.referenceDragging = false;
        this.questionForm = {
            id: '',
            content: '',
            answerType: 'scale5',
            existingReferences: [],
            referenceFiles: [],
            removedReferenceIds: []
        };
    }

    private releaseReferencePreviews() {
        for (const reference of this.questionForm.referenceFiles || []) {
            if (reference.preview) URL.revokeObjectURL(reference.preview);
        }
    }

    private message(data: any, fallback: string): string {
        if (data && typeof data === 'object' && data.message) return data.message;
        if (typeof data === 'string' && data) return data;
        return fallback;
    }
}

export default PageRailwayPerformanceComponent;